import { render, staticRenderFns } from "./CommissionDeferredList.vue?vue&type=template&id=a2b9d574&"
import script from "./CommissionDeferredList.vue?vue&type=script&lang=js&"
export * from "./CommissionDeferredList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports